import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import authRoles from '@auth/authRoles';
import { lazyRetry } from '@utils/lazyRetry';

const ResetPasswordPage = lazyRetry(() => import('./ResetPasswordPage'));

const ResetPasswordPageRoute: FuseRouteItemType = {
  path: 'reset-password',
  element: <ResetPasswordPage />,
  settings: {
    layout: {
      config: {
        navbar: {
          display: false
        },
        toolbar: {
          display: false
        },
        footer: {
          display: false
        },
        leftSidePanel: {
          display: false
        },
        rightSidePanel: {
          display: false
        }
      }
    }
  },
  auth: authRoles.onlyGuest // []
};

export default ResetPasswordPageRoute;
